import {
  DISMISS_DISCOVERY_BANNER,
  FETCH_DEMO_MODE_BANNER_ASYNC,
  HIDE_DISCOVERY_BANNER,
} from './constants'

export const fetchDemoBannerStatusSuccess = (data) => ({
  type: FETCH_DEMO_MODE_BANNER_ASYNC.SUCCESS,
  payload: { data },
})
export const fetchDemoBannerStatusError = (error) => ({
  type: FETCH_DEMO_MODE_BANNER_ASYNC.ERROR,
  error,
})

// Discovery-banner fetch uses the built-in createAsyncTypes creators
// (FETCH_DISCOVERY_BANNER_ASYNC.onSuccess/onError) — no custom creators needed.
export const dismissDiscoveryBanner = () => ({ type: DISMISS_DISCOVERY_BANNER })

export const hideDiscoveryBanner = (reason) => ({
  type: HIDE_DISCOVERY_BANNER,
  payload: { reason },
})
